import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { usePerks } from '../../hooks/usePerks';
export const RuneIcon = t0 => {
  const $ = _c(57);
  const {
    runeId,
    size: t1,
    className: t2,
    showTitle: t3
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  const className = t2 === undefined ? "" : t2;
  const showTitle = t3 === undefined ? false : t3;
  const {
    data: perksData,
    isLoading,
    error
  } = usePerks();
  if (isLoading) {
    let t4;
    if ($[0] !== size) {
      t4 = {
        width: size,
        height: size,
        border: "1px solid #333",
        backgroundColor: "#2a2a2a"
      };
      $[0] = size;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== className || $[3] !== t4) {
      t5 = <div className={className} style={t4} />;
      $[2] = className;
      $[3] = t4;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    return t5;
  }
  if (error || !perksData) {
    let t4;
    if ($[5] !== size) {
      t4 = {
        width: size,
        height: size,
        border: "1px solid #333",
        backgroundColor: "#2a2a2a"
      };
      $[5] = size;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== className || $[8] !== t4) {
      t5 = <div className={className} style={t4} />;
      $[7] = className;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  const t4 = perksData.styles;
  let t5;
  if ($[10] !== className || $[11] !== perksData.styles || $[12] !== runeId || $[13] !== showTitle || $[14] !== size) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t6;
      if ($[16] !== runeId) {
        t6 = style => style.id === runeId;
        $[16] = runeId;
        $[17] = t6;
      } else {
        t6 = $[17];
      }
      const runeTree = t4.find(t6);
      if (runeTree) {
        const fileName = runeTree.iconPath.split("/").pop()?.toLowerCase();
        const iconUrl = `https://raw.communitydragon.org/latest/game/assets/perks/styles/${fileName}`;
        const t7 = showTitle ? runeTree.name : undefined;
        let t8;
        if ($[18] !== size) {
          t8 = {
            width: size,
            height: size,
            objectFit: "contain",
            border: "1px solid #333"
          };
          $[18] = size;
          $[19] = t8;
        } else {
          t8 = $[19];
        }
        const t9 = e => {
          const target = e.target as HTMLImageElement;
          target.style.display = "none";
          console.error(`Failed to load rune tree icon for ID: ${runeId}, name: ${runeTree.name}`);
        };
        let t10;
        if ($[20] !== className || $[21] !== iconUrl || $[22] !== runeTree || $[23] !== size || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
          t10 = <Image src={iconUrl} alt={runeTree.name} width={size} height={size} title={t7} className={className} style={t8} onError={t9} />;
          $[20] = className;
          $[21] = iconUrl;
          $[22] = runeTree;
          $[23] = size;
          $[24] = t7;
          $[25] = t8;
          $[26] = t9;
          $[27] = t10;
        } else {
          t10 = $[27];
        }
        t5 = t10;
        break bb0;
      }
    }
    $[10] = className;
    $[11] = perksData.styles;
    $[12] = runeId;
    $[13] = showTitle;
    $[14] = size;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  const t6 = perksData.perks;
  let perk;
  let perkName;
  let styleName;
  let t7;
  let t8;
  if ($[28] !== className || $[29] !== perksData.perks || $[30] !== runeId || $[31] !== size) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb1: {
      let t9;
      if ($[37] !== runeId) {
        t9 = p => p.id === runeId;
        $[37] = runeId;
        $[38] = t9;
      } else {
        t9 = $[38];
      }
      perk = t6.find(t9);
      if (!perk) {
        console.error(`Perk not found for ID: ${runeId}`);
        let t10;
        if ($[39] !== size) {
          t10 = {
            width: size,
            height: size,
            border: "1px solid #333",
            backgroundColor: "#2a2a2a"
          };
          $[39] = size;
          $[40] = t10;
        } else {
          t10 = $[40];
        }
        let t11;
        if ($[41] !== className || $[42] !== t10) {
          t11 = <div className={className} style={t10} />;
          $[41] = className;
          $[42] = t10;
          $[43] = t11;
        } else {
          t11 = $[43];
        }
        t8 = t11;
        break bb1;
      }
      const pathParts = perk.iconPath.split("/");
      styleName = pathParts[pathParts.length - 3]?.toLowerCase() || "";
      perkName = pathParts[pathParts.length - 2]?.toLowerCase() || "";
      t7 = pathParts[pathParts.length - 1]?.toLowerCase() || "";
    }
    $[28] = className;
    $[29] = perksData.perks;
    $[30] = runeId;
    $[31] = size;
    $[32] = perk;
    $[33] = perkName;
    $[34] = styleName;
    $[35] = t7;
    $[36] = t8;
  } else {
    perk = $[32];
    perkName = $[33];
    styleName = $[34];
    t7 = $[35];
    t8 = $[36];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  const fileName_0 = t7;
  const iconUrl_0 = `https://raw.communitydragon.org/latest/game/assets/perks/styles/${styleName}/${perkName}/${fileName_0}`;
  const t9 = `${perk.name} (${runeId})`;
  const t10 = showTitle ? perk.name : undefined;
  let t11;
  if ($[44] !== size) {
    t11 = {
      width: size,
      height: size,
      objectFit: "contain",
      border: "1px solid #333"
    };
    $[44] = size;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] !== perk.name || $[47] !== runeId) {
    t12 = e_0 => {
      const target_0 = e_0.target as HTMLImageElement;
      target_0.style.display = "none";
      console.error(`Failed to load rune icon for ID: ${runeId}, name: ${perk.name}`);
    };
    $[46] = perk.name;
    $[47] = runeId;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  let t13;
  if ($[49] !== className || $[50] !== iconUrl_0 || $[51] !== size || $[52] !== t10 || $[53] !== t11 || $[54] !== t12 || $[55] !== t9) {
    t13 = <Image src={iconUrl_0} alt={t9} title={t10} className={className} width={size} height={size} style={t11} onError={t12} />;
    $[49] = className;
    $[50] = iconUrl_0;
    $[51] = size;
    $[52] = t10;
    $[53] = t11;
    $[54] = t12;
    $[55] = t9;
    $[56] = t13;
  } else {
    t13 = $[56];
  }
  return t13;
};